var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGmsEntriesWidgets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3332 5.66678H18.4168V8.5H28.3336L28.3332 5.66678ZM28.3332 9.91678H18.4168V12.75H28.3336L28.3332 9.91678ZM17 5.66678H11.3332V12.75H17V5.66678ZM28.3332 14.1668H11.3332V17H28.3332V14.1668ZM28.3332 18.4168H11.3332V21.25H28.3332V18.4168ZM31.1668 2.83322V28.3332C31.1668 30.4582 30.4586 31.1664 28.3336 31.1664H5.66678C3.54178 31.1664 2.83356 30.4582 2.83356 28.3332V8.5H5.66678V28.3332H8.5V2.83322H31.1668ZM25.5 22.6668H11.3332V25.5H25.5V22.6668ZM32.5832 0H7.08322C5.66644 0 5.66644 0.0142799 5.66644 1.41678V5.66678H1.41644C0 5.66678 0 5.68072 0 7.08322V28.3332C0 31.875 2.125 34 5.66678 34H28.3336C31.875 34 34 31.875 34 28.3332V1.41678C34 0.0142799 34 0 32.5832 0Z",
    fill: "#3BBEE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmsEntriesWidgets);
export default __webpack_public_path__ + "static/media/gms-entries-widgets.586d589a77349b84bb84df3db3f656ae.svg";
export { ForwardRef as ReactComponent };